// Computes unstoppable streak stats from the history array.
// Streak = consecutive days where w_shipped === 'yes', going back from today.
// A missing day or w_shipped !== 'yes' breaks the streak.

function computeLongest(history) {
  if (!history.length) return 0
  const sorted = [...history].sort((a, b) => a.date.localeCompare(b.date))
  let longest = 0
  let temp = 0
  let prevDate = null
  for (const row of sorted) {
    if (row.w_shipped !== 'yes') { temp = 0; prevDate = null; continue }
    if (!prevDate) {
      temp = 1
    } else {
      const diffDays = Math.round(
        (new Date(row.date + 'T00:00:00') - new Date(prevDate + 'T00:00:00')) / 86400000
      )
      temp = diffDays === 1 ? temp + 1 : 1
    }
    if (temp > longest) longest = temp
    prevDate = row.date
  }
  return longest
}

export function computeUnstoppableStreak(history) {
  if (!history || history.length === 0) {
    return { currentStreak: 0, longestStreak: 0, totalShipped: 0 }
  }

  const todayISO = new Date().toISOString().split('T')[0]
  const map = {}
  history.forEach(row => { map[row.date] = row })

  const todayEntry = map[todayISO]

  // If today's loop is closed and W did NOT ship, streak is 0
  if (todayEntry?.closed_at && todayEntry?.w_shipped !== 'yes') {
    return {
      currentStreak: 0,
      longestStreak: computeLongest(history),
      totalShipped: history.filter(r => r.w_shipped === 'yes').length,
    }
  }

  // Count current streak going back day by day
  let currentStreak = todayEntry?.w_shipped === 'yes' ? 1 : 0
  const cursor = new Date()
  cursor.setDate(cursor.getDate() - 1)
  for (let i = 0; i < 60; i++) {
    const iso = cursor.toISOString().split('T')[0]
    if (map[iso]?.w_shipped === 'yes') {
      currentStreak++
      cursor.setDate(cursor.getDate() - 1)
    } else {
      break
    }
  }

  return {
    currentStreak,
    longestStreak: computeLongest(history),
    totalShipped: history.filter(r => r.w_shipped === 'yes').length,
  }
}

export const MILESTONE_MESSAGES = {
  7:   "One week unstoppable. Most people quit by now.",
  14:  "Two weeks. This is becoming who you are.",
  21:  "21 days. Science says this is a habit now.",
  30:  "30 days unstoppable. You're in the top 1% of users.",
  50:  "50 days. This isn't discipline anymore. It's identity.",
  100: "100 days unstoppable. You are the system.",
}

export const MILESTONE_DAYS = [7, 14, 21, 30, 50, 100]

export function getMilestoneMessage(streak) {
  return MILESTONE_MESSAGES[streak] || null
}

export function isMilestoneShown(streak) {
  try { return localStorage.getItem(`ros_milestone_${streak}`) === '1' } catch { return false }
}

export function markMilestoneShown(streak) {
  try { localStorage.setItem(`ros_milestone_${streak}`, '1') } catch {}
}
